<template>
  <v-list>
    <v-list-item>
      <v-list-item-content>
        <v-btn depressed @click="handleBack" color="primary" outline block>Back</v-btn>
      </v-list-item-content>
    </v-list-item>
    <v-list-item :class="answer[0].QuestionID === selectedQID ? 'selectedQuestion' : ''" color="primary"
                 style="border-bottom: 1px solid #ccc"
                 v-for="(answer, qKey) in ASSESSMENT" :key="qKey"
                 @click="handleQuestionSelect(answer[0])">
      <v-list-item-content>
        <!--
                <v-list-tile-title>{{answer[0].QuestionNumber}}</v-list-tile-title>
        -->
        <v-list-item-title class="text-wrap">{{ getQuestionTitle(answer[0].QuestionID) }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import {mapActions, mapMutations, mapGetters} from 'vuex'

export default {
  name: 'ScoringAnswerList',

  computed: {
    ...mapGetters({
      ASSESSMENT: 'GET_SELECTED_ASSESSMENT',
      ASSESSEE_ROUTE: 'GET_ANSWER_DATA'
    })
  },

  data() {
    return {
      selectedQID: null,
    }
  },

  methods: {
    ...mapActions(['MARK_FETCH_ANSWER_DATA']),
    ...mapMutations(['SET_TASK']),
    getQuestionTitle(id) {
      let title = this.$store.getters['GET_QUESTION_TITLE_BY_QMID'](id);
      console.dir(title);
      return title !== null ? title : id
    },
    handleQuestionSelect(question) {
      this.selectedQID = question.QuestionID;
      question.selected = true;
      console.log(question['odata.mediaReadLink']);
      this.$router.push('/mark');
      this.MARK_FETCH_ANSWER_DATA({
        candidateDataURL: question['odata.mediaReadLink'],
        assessorQuestionID: question.QuestionID
      }).then(() => {
        this.$router.replace({
          name: 'AnswerMap'
        })
      }).catch(err => {
        if (err.response.data.status && err.response.data.context === 'question_get_linked_id') {
          alert('The linked id is not valid and could not be matched to a question.')
        }
      });
    },
    handleBack() {
      //this.$emit('back')
      this.SET_TASK('select_result')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.selectedQuestion {
  background: rgba(38, 55, 70, 0.3);
}
</style>
